import { createSlice } from "@reduxjs/toolkit";

const initialToastState = {
  type: "",
  status: false,
  header: null,
  message: null,
};

export const toastSlice = createSlice({
  name: "toastSlice",
  initialState: initialToastState,
  reducers: {
    onSuccess: (state, action) => {
      const { message, header } = action?.payload;
      state.status = true;
      state.type = "success";
      state.message = message;
      state.header = header;
    },
    onError: (state, action) => {
      const { message, header } = action?.payload?.statusData;
      state.status = true;
      state.type = "error";
      state.message = message;
      state.header = header;
    },
    resetToast: (state) => {
      state.status = false;
      state.type = "";
      state.message = null;
      state.header = null;
    },
  },
});
